import { DateView } from "@mui/x-date-pickers";

export const DATE_VIEW_FORMAT_RECORD: Record<DateView, string> = {
  day: "dd",
  month: "MM",
  year: "yyyy",
};
